import React, { useEffect } from 'react';
import {
  Modal,
  FormInputColumn,
  FormSelect,
  FormInput,
  FormContainer,
  Box,
  Paragraph,
  Cluster,
} from '@thecb/components';
// Build redux freeform for cancel order modal form
import { createFormState, required } from 'redux-freeform';
import { formatPrice, formatWithParentheses } from '../../utils/helpers';

const reasonOptions = [
  {
    text: 'Constituent Walked Away',
    value: '1',
  },
  {
    text: 'Constituent Had No Money',
    value: '2',
  },
  {
    text: 'Credit Card Was Declined',
    value: '3',
  },
  {
    text: 'Check Verification Failed',
    value: '4',
  },
  {
    text: 'Debt Already Paid',
    value: '5',
  },
  {
    text: 'Other',
    value: '6',
  },
];

const formConfig = {
  reason: {
    defaultValue: '1',
    validators: [required()],
  },
  note: {
    validators: [required()],
  },
};

const { reducer, mapStateToProps, mapDispatchToProps } =
  createFormState(formConfig);

const CANCEL_ORDER_FORM_MODAL = 'CANCEL_ORDER_FORM_MODAL';
const CancelOrderFormModal = ({
  fields,
  actions,
  modals,
  showErrors,
  submit,
  toggle,
}) => {
  useEffect(() => {
    return () => actions.form.clear();
  }, []);

  const reasonErrors = {
    [required.error]: 'Reason for Cancellation Required',
  };
  const noteErrors = {
    [required.error]: 'Note Required',
  };
  const body = (
    <FormContainer>
      <FormInputColumn role="form" aria-label="Cancel Order">
        <FormSelect
          dropdownMaxHeight="200px"
          labelTextWhenNoError="Reason"
          options={reasonOptions}
          fieldActions={actions.fields.reason}
          showErrors={showErrors}
          errorMessages={reasonErrors}
          field={fields.reason}
          labelTextVariant="p"
          errorLabelTextVariant="p"
        />
        <FormInput
          labelTextWhenNoError="Note"
          errorMessages={noteErrors}
          field={fields.note}
          errors={showErrors}
          fieldActions={actions.fields.note}
          labelTextVariant="p"
          errorTextVariant="p"
        />
      </FormInputColumn>
    </FormContainer>
  );

  return (
    <Modal
      modalHeaderText="Cancel Order"
      modalBodyText={body}
      modalOpen={
        modals.cartModal.modalIsOpen &&
        modals.cartModal.modalId === CANCEL_ORDER_FORM_MODAL
      }
      toggleModal={toggle}
      continueAction={submit}
      cancelAction={toggle}
      defaultWrapper={false}
    />
  );
};

CancelOrderFormModal.reducer = reducer;
CancelOrderFormModal.mapStateToProps = mapStateToProps;
CancelOrderFormModal.mapDispatchToProps = mapDispatchToProps;

const REMOVE_ITEM_MODAL = 'REMOVE_ITEM_MODAL';
const RemoveItemModal = ({ modals, submit, toggle, item = {} }) => {
  const body = (
    <Box padding="0">
      <Cluster justify="space-between">
        <Paragraph fontSize="1rem" weight="600">
          {item.receivable_category}
        </Paragraph>
        <Paragraph>
          {item.is_negative_amount
            ? formatWithParentheses(formatPrice(item.recorded_subtotal))
            : formatPrice(item.recorded_subtotal)}
        </Paragraph>
      </Cluster>
    </Box>
  );

  return (
    <Modal
      modalHeaderText="Are you sure you want to remove this item?"
      modalBodyText={body}
      modalOpen={
        modals.cartModal.modalIsOpen &&
        modals.cartModal.modalId === REMOVE_ITEM_MODAL
      }
      toggleModal={toggle}
      continueAction={submit}
      cancelAction={toggle}
      defaultWrapper={false}
    />
  );
};

export {
  CANCEL_ORDER_FORM_MODAL,
  REMOVE_ITEM_MODAL,
  CancelOrderFormModal,
  RemoveItemModal,
};
